const $menuTrigger = document.querySelectorAll('.js--header__main_burger');
const $topNav = document.querySelector('.js--top_push_nav');
const $openLevel = document.querySelectorAll('.js--openSection');
const $closeLevel = document.querySelectorAll('.js-closeLevel');
const $closeLevelTop = document.querySelectorAll('.js--close_level_top');
const $navLevel = document.querySelectorAll('.js-pushNavLevel');
const $body = document.body;
const $root = document.getElementsByTagName( 'html' )[0];
const $screen = document.querySelector('.screen');
const sections = document.querySelectorAll('.js--header_section');
const subSections = document.querySelectorAll('.js--subsections');
const header = document.querySelector('.js--header');

if (header) {
  const openPushNav = () => {
    $topNav.classList.add('isOpen');
    $body.classList.add('menuIsOpen');
    $root.classList.add('menuIsOpen');
  };

  const closePushNav = () => {
    $topNav.classList.remove('isOpen');
    $navLevel.forEach(nav => nav.classList.remove('isOpen'));
    $body.classList.remove('menuIsOpen');
    $root.classList.remove('menuIsOpen');
  };

  $menuTrigger.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      // e.stopPropagation();
      if ($topNav.classList.contains('isOpen')) {
        closePushNav();
      } else {
        openPushNav();
      }
    });
  });

  $openLevel.forEach(open => {
    open.addEventListener('click', function(e) {
      // e.stopPropagation();
      this.nextElementSibling.classList.add('isOpen');
    });

  });

  $closeLevel.forEach(close => {
    close.addEventListener('click', function(e) {
      // e.stopPropagation();
      this.closest('.js-pushNavLevel').classList.remove('isOpen');
    });

  });

  $closeLevelTop.forEach(closeTop => {
    closeTop.addEventListener('click', closePushNav);
  });

  $screen.addEventListener('click', closePushNav);


// Функция для проверки наличия вертикального скроллбара
  function hasVerticalScrollbar(element) {
    return element.scrollHeight > element.clientHeight;
  }


  const sectionList = document.querySelector('.js--section_list');
  const submenuLinks = document.querySelector('.js--submenu_links');
  const submenuSectionList = document.querySelector('.header__submenu_section_list--submenu');
  const submenuSubSectionList = document.querySelector('.header__submenu_subsection_list_wrap');
  const submenuSubSectionListActive = document.querySelector('.header__submenu_subsection_list_wrap.active .header__submenu_subsection_list_inner');
  const submenuSubSectionListInner = document.querySelector('.header__submenu_subsection_list_inner');
  const submenuSubSectionListRight = document.querySelector('.header__submenu_subsection_list_wrap_inner--right .header__submenu_subsection_list_inner');
  const submenuSubSectionListRightWrap = document.querySelector('.header__submenu_subsection_list_wrap_inner--right');
  const submenuSubSectionListLeftMenu = document.querySelector('.header__submenu_subsection_list_wrap_inner--left .header__submenu_section_list--submenu');

  function updateButtonVisibility() {
    sectionList.previousElementSibling.style.visibility = sectionList.scrollTop > 0 ? 'visible' : 'hidden';
    sectionList.nextElementSibling.style.visibility = sectionList.scrollTop + sectionList.clientHeight < sectionList.scrollHeight ? 'visible' : 'hidden';

    submenuLinks.previousElementSibling.style.visibility = submenuLinks.scrollTop > 0 ? 'visible' : 'hidden';
    submenuLinks.nextElementSibling.style.visibility = submenuLinks.scrollTop + submenuLinks.clientHeight < submenuLinks.scrollHeight ? 'visible' : 'hidden';

    submenuSectionList.previousElementSibling.style.visibility = submenuSectionList.scrollTop > 0 ? 'visible' : 'hidden';
    submenuSectionList.nextElementSibling.style.visibility = submenuSectionList.scrollTop + submenuSectionList.clientHeight < submenuSectionList.scrollHeight ? 'visible' : 'hidden';

    submenuSubSectionListActive.previousElementSibling.style.visibility = submenuSubSectionListActive.scrollTop > 0 ? 'visible' : 'hidden';
    submenuSubSectionListActive.nextElementSibling.style.visibility = submenuSubSectionListActive.scrollTop + submenuSubSectionListActive.clientHeight < submenuSubSectionListActive.scrollHeight ? 'visible' : 'hidden';

    submenuSubSectionListRight.previousElementSibling.style.visibility = submenuSubSectionListRight.scrollTop > 0 ? 'visible' : 'hidden';
    submenuSubSectionListRight.nextElementSibling.style.visibility = submenuSubSectionListRight.scrollTop + submenuSubSectionListRight.clientHeight < submenuSubSectionListRight.scrollHeight ? 'visible' : 'hidden';

    submenuSubSectionListLeftMenu.previousElementSibling.style.visibility = submenuSubSectionListLeftMenu.scrollTop > 0 ? 'visible' : 'hidden';
    submenuSubSectionListLeftMenu.nextElementSibling.style.visibility = submenuSubSectionListLeftMenu.scrollTop + submenuSubSectionListLeftMenu.clientHeight < submenuSubSectionListLeftMenu.scrollHeight ? 'visible' : 'hidden';
  }
  function updateButtonVisibilityInTab() {
    this.previousElementSibling.style.visibility = this.scrollTop > 0 ? 'visible' : 'hidden';
    this.nextElementSibling.style.visibility = this.scrollTop + this.clientHeight < this.scrollHeight ? 'visible' : 'hidden';
  }
  function initButtonVisibilityInTab(el) {
    el.previousElementSibling.style.visibility = el.scrollTop > 0 ? 'visible' : 'hidden';
    el.nextElementSibling.style.visibility = el.scrollTop + el.clientHeight < el.scrollHeight ? 'visible' : 'hidden';
  }

  function scrollSectionList(elem, amount) {
    elem.scrollBy({
      top: amount,
      behavior: 'smooth'
    });
  }

// Проверим наличие скроллбара и добавим/удалим класс
  if (hasVerticalScrollbar(sectionList)) {
    sectionList.parentElement.classList.add('has_scrollbar');
  } else {
    sectionList.parentElement.classList.remove('has_scrollbar');
  }
  if (hasVerticalScrollbar(submenuLinks)) {
    submenuLinks.parentElement.classList.add('has_scrollbar');
  } else {
    submenuLinks.parentElement.classList.remove('has_scrollbar');
  }
  if (hasVerticalScrollbar(submenuSectionList)) {
    submenuSectionList.classList.add('has_scrollbar');
  } else {
    submenuSectionList.classList.remove('has_scrollbar');
  }
  if (hasVerticalScrollbar(submenuSubSectionList)) {
    submenuSubSectionList.classList.add('has_scrollbar');
  } else {
    submenuSubSectionList.classList.remove('has_scrollbar');
  }
  if (hasVerticalScrollbar(submenuSubSectionListRight)) {
    submenuSubSectionListRightWrap.classList.add('has_scrollbar');
  } else {
    submenuSubSectionListRightWrap.classList.remove('has_scrollbar');
  }
  const menuButton = document.querySelector('.js--submenu_show');
  menuButton.addEventListener('click', (event) => {

    const element = document.querySelector('.js--header__submenu');
    element.classList.toggle('show');
    $body.classList.toggle('menuIsOpen');
    $root.classList.toggle('menuIsOpen');
    updateButtonVisibility();

  });

  document.addEventListener('click', (event) => {
    const elements = document.querySelectorAll('.js--header__submenu.show');
    elements.forEach(element => {
      if (!element.contains(event.target) && !menuButton.contains(event.target)) {
        element.classList.remove('show');
        $body.classList.remove('menuIsOpen');
        $root.classList.remove('menuIsOpen');
      }
    });
  });
  document.addEventListener('DOMContentLoaded', () => {



    document.querySelectorAll('.js--scroll_up').forEach((item) =>  {
      item.addEventListener('click', function () {
        scrollSectionList(this.nextElementSibling,-48);
      });
    });


    document.querySelectorAll('.js--scroll_down').forEach((item) =>  {
      item.addEventListener('click', function () {
        scrollSectionList(this.previousElementSibling,48);
      });
    });
    // Добавление и удаление стрелок в Разделах при скролле
    sectionList.addEventListener('scroll', updateButtonVisibility);
    // Добавление и удаление стрелок в Быстрых ссылках при скролле
    submenuLinks.addEventListener('scroll', updateButtonVisibility);
    // Добавление и удаление стрелок в Подразделах при скролле
    submenuSectionList.addEventListener('scroll', updateButtonVisibility);

    submenuSubSectionList.addEventListener('scroll', updateButtonVisibility);


    submenuSubSectionListRight.addEventListener('scroll', updateButtonVisibility);



    sections.forEach(item => {
      item.style.setProperty('--section-hover-color', item.getAttribute('data-color'));
      if (item.hasAttribute('data-bs-target')) {
        const targetId = item.getAttribute('data-bs-target');
        if (targetId) {

          const targetElement = document.getElementById(targetId.replace('#', ''));

          if (targetElement) {
            const children = targetElement.querySelectorAll('.header__submenu_subsection_list li');
            const childrenSubmenu = targetElement.querySelectorAll('.header__submenu_section_list--submenu li');
            const childrenMain = targetElement.querySelectorAll('.header__submenu_subsection_main a');
            const childrenNoSubmenuSubsection = targetElement.querySelectorAll('.header__submenu_subsection_list--no_submenu a');

            children.forEach(child => {
              child.style.setProperty('--child-marker-color', item.getAttribute('data-color'));
            });
            childrenSubmenu.forEach(child => {
              child.style.setProperty('--child-marker-color', item.getAttribute('data-color'));
            });
            childrenMain.forEach(child => {
              child.style.setProperty('--child-marker-color', item.getAttribute('data-color'));
            });
            childrenNoSubmenuSubsection.forEach(child => {
              child.style.setProperty('--child-marker-color', item.getAttribute('data-color'));
            });
          }


        }
        const tab = document.getElementById(targetId.replace('#', ''));
        const menu = tab.querySelector('.header__submenu_subsection_list_inner');
        const noSubmenuMenu = tab.querySelector('.header__submenu_subsection_list--no_submenu');
        const submenuMenu = tab.querySelector('.header__submenu_section_list--submenu');
        const submenuMenuLeft = tab.querySelector('.header__submenu_subsection_list_wrap_inner--left .header__submenu_section_list--submenu');


        if (!noSubmenuMenu) {
          initButtonVisibilityInTab(menu);
        }
        // initButtonVisibilityInTab(submenuMenuLeft);
        if (tab.classList.contains('header__submenu_subsection_list_wrap--has_submenu')) {
          initButtonVisibilityInTab(submenuMenu);
        }
        // Добавление удаление стрелок в Табе Раздела (если нет вложенного меню) при скролле
        menu.addEventListener('scroll', updateButtonVisibilityInTab);
        tab.scrollTo(0, 0);
        item.addEventListener('shown.bs.tab', event => {

          if (tab.classList.contains('header__submenu_subsection_list_wrap--has_submenu')) {
            initButtonVisibilityInTab(submenuMenu);
          }

          if (!noSubmenuMenu) {
            // Добавление удаление стрелок в Табе Раздела (если нет вложенного меню) при переключении таба в Разделе
            initButtonVisibilityInTab(menu);
          }
          if (hasVerticalScrollbar(menu) && !tab.classList.contains('header__submenu_subsection_list_wrap--has_submenu')) {
            menu.addEventListener('scroll', updateButtonVisibilityInTab);
            tab.scrollTo(0, 0);
          }


          subSections.forEach(subSectionsItem => {
            const subSectionsTargetId = subSectionsItem.getAttribute('data-bs-target');
            const subSectionsTab = document.getElementById(subSectionsTargetId.replace('#', ''));
            const subSectionsMenu = subSectionsTab.querySelector('.header__submenu_subsection_list_inner--submenu');
            subSectionsItem.addEventListener('shown.bs.tab', event => {

              // Добавление удаление стрелок в Табе Подраздела при переключении таба в Разделе
              initButtonVisibilityInTab(subSectionsMenu);

              if (hasVerticalScrollbar(subSectionsMenu)) {
                subSectionsTab.parentElement.classList.add('has_scrollbar');
                // subSectionsMenu.addEventListener('scroll', updateButtonVisibilityInTab);
                subSectionsTab.scrollTo(0, 0);
              } else {
                subSectionsTab.parentElement.classList.remove('has_scrollbar');
              }

            });
          });


        });
      }

    });
    subSections.forEach(subSectionsItem => {
      const subSectionsTargetId = subSectionsItem.getAttribute('data-bs-target');
      const subSectionsTab = document.getElementById(subSectionsTargetId.replace('#', ''));
      const subSectionsMenu = subSectionsTab.querySelector('.header__submenu_subsection_list_inner');

      initButtonVisibilityInTab(subSectionsMenu);
      subSectionsMenu.addEventListener('scroll', updateButtonVisibilityInTab);

      subSectionsItem.addEventListener('shown.bs.tab', event => {

        initButtonVisibilityInTab(subSectionsMenu);

        if (hasVerticalScrollbar(subSectionsMenu)) {
          subSectionsTab.parentElement.classList.add('has_scrollbar');
          subSectionsMenu.addEventListener('scroll', updateButtonVisibilityInTab);
          subSectionsTab.scrollTo(0, 0);
        } else {
          subSectionsTab.parentElement.classList.remove('has_scrollbar');
        }

      });
    });
  });
}


